<div class="flex items-center rounded justify-between ion-activatable relative overflow-hidden cursor-pointer w-fit mb-6">
  <ion-ripple-effect></ion-ripple-effect>
  <div class="flex flex-col items-center">
    <div
      class="image aspect-square rounded-top-md image"
      [ngStyle]="{ background: 'url(' + (category.image || 'assets/icons/icon-256.webp') + ')' }"
    ></div>
    <div class="h-[60px] bg-[#EBF6FB] w-full flex items-center justify-between px-3 title">
      <ion-label color="secondary">
        {{ category.name }}
      </ion-label>
      <ion-icon
        class="text-[18px]"
        name="chevron-forward-outline"
        color="secondary"
      ></ion-icon>
    </div>
  </div>
</div>
